import {NavLink, useLocation} from "react-router-dom";
import "../style.css"
import {useState} from "react";
import DialAddNewProj from "../app-mapper/_subcomponents/DialAddNewProj";
import * as React from "react";


export default function TopNavBar(props: any) {

    const {user, logoutUser, projName, topNavItems} = props

    let location = useLocation()

    let currentRootLoc = location.pathname.split('/')[4]
    // console.log(location.pathname, '-->', currentRootLoc)

    let mapRootsToLocation: any = {
        'Project stats': 'details',
        'Map Fields': 'fields',
        'Map Specs': 'feats',
        'Products': 'prods',
        'Reports': 'reports',
        'Templates': 'templates',
    }
    // console.log(topNavItems.length)

    const barGrid = projName ? `20% 75% 5%` : `88% 12%`

    const elemsGrid = `repeat(${topNavItems.length + 1}, auto)`

    const navbarElems = topNavItems.map((item: any, index: number) => {
        let rootName: string = item.name

        return (
            <NavLink
                key={index + 1}
                to={item.link}
                className={mapRootsToLocation[rootName] === currentRootLoc ? "topnavbar-item-active" : "topnavbar-item"}
                // style={mapRootsToLocation[rootName] === keyLoc ? activeClassStyle : {color: "white"}}
                // style={({isActive}) => setStyleActive(isActive)}    // old version, works without nested routes
            >
                {rootName}
            </NavLink>
        )
    })

    const allowedUsers = ['ilya', 'dimab']
    const isAdmin = allowedUsers.includes(user.username)

    const [dialOpen, setDialOpen] = useState<any>(false);

    const [projObj, setProjObj] = useState<any>({
        srcTaxID: '',
        srcTaxName: '',
        trgTaxID: '',
        trgTaxName: '',
    })
    // console.log(projObj)

    let logoutRender;
    if (!projName && isAdmin) {
        logoutRender = <>
            <div className="mainpage-newproj-logout">
                <DialAddNewProj
                    open={dialOpen}
                    setOpen={setDialOpen}
                    projObj={projObj}
                    setProjObj={setProjObj}
                />
                <div className="topnavbar-item" style={{cursor: 'pointer'}}
                     onClick={() => setDialOpen(true)}>New project
                </div>
                <div className="topnavbar-item" style={{cursor: 'pointer'}} onClick={logoutUser}>Logout
                </div>
            </div>
        </>

    } else if (!projName && !isAdmin) {
        logoutRender = <div style={{display: "grid", gridTemplateColumns: "50% 50%"}}>
            <div></div>
            <div className="topnavbar-item" style={{cursor: 'pointer'}} onClick={logoutUser}>Logout</div>
        </div>
    } else {
        logoutRender = <div className="topnavbar-item" style={{cursor: 'pointer'}} onClick={logoutUser}>Logout</div>
    }


    return (
        <>
            <div className='topnavbar' style={{gridTemplateColumns: barGrid}}>
                {projName && <div className='topnavbar-proj-name'>{projName}</div>}
                <div className="topnavbar-departments" style={{gridTemplateColumns: elemsGrid}}>
                    {navbarElems}
                </div>

                {logoutRender}

            </div>
        </>
    )
}
